/**
 * @fileoverview In-memory transport for the differential client Store.
 *
 * Implements the Transport interface without any network calls. All state
 * is kept in memory. Used for local-only documents that don't have a
 * Reboot collab session.
 *
 * @module LocalTransport
 */
import type { ChangeEntry, RawOperation, Row, Transport } from "./Transport";

export class LocalTransport implements Transport {
	private version = 0;
	private readonly log: ChangeEntry[] = [];

	async mutate(
		_lastSeenVersion: number,
		operations: RawOperation[]
	): Promise<{ version: number; changes: ChangeEntry[] }> {
		const changes: ChangeEntry[] = operations.map((op) => ({
			version: ++this.version,
			operation: op,
		}));
		this.log.push(...changes);
		return { version: this.version, changes };
	}

	async state(): Promise<{ version: number; tables: Record<string, Row[]> }> {
		return { version: this.version, tables: {} };
	}

	async changes(sinceVersion: number): Promise<{ version: number; changes: ChangeEntry[] }> {
		const changes = this.log.filter((e) => e.version > sinceVersion);
		return { version: this.version, changes };
	}
}
